// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type UsergroupsCreateResponse = SlackAPIResponse & {
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  usergroup?: Usergroup;
};

export interface Usergroup {
  auto_provision?: boolean;
  channel_count?: number;
  created_by?: string;
  date_create?: number;
  date_delete?: number;
  date_update?: number;
  description?: string;
  enterprise_subteam_id?: string;
  handle?: string;
  id?: string;
  is_editing_restricted?: boolean;
  is_external?: boolean;
  is_idp_group?: boolean;
  is_membership_locked?: boolean;
  is_org_level?: boolean;
  is_section?: boolean;
  is_subteam?: boolean;
  is_usergroup?: boolean;
  is_visible?: boolean;
  name?: string;
  prefs?: Prefs;
  team_id?: string;
  updated_by?: string;
  users?: string[];
}

export interface Prefs {
  channels?: string[];
  groups?: string[];
}
